import { Entry } from '../Entry'

export function Entry20231102() {
  return (
    <Entry title="Nov 02 2023 - v3.5.4">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15560/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
